import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import _isEqual from 'lodash/isEqual';
import Button from 'components/Button';
import './style.scss';

export default class RadioButton extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    item: PropTypes.shape({
      id: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }),
    name: PropTypes.string,
    handleClick: PropTypes.func,
    isActive: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    isActive: false,
  };

  shouldComponentUpdate(nextProps) {
    return !_isEqual(nextProps.isActive, this.props.isActive);
  }

  handleClick = () => {
    const { handleClick, item, name } = this.props;

    handleClick(item, name);
  };

  render() {
    const { className, isActive, children } = this.props;

    return (
      <Button isRadio className={className} onClick={this.handleClick}>
        <span
          styleName={cn('radio', {
            'is-active': isActive,
          })}
        />
        <span styleName="text">{children}</span>
      </Button>
    );
  }
}
